export const firstToUpper = (str: string): string => {
    return str.replace(/^./, str[0].toUpperCase())
}